export default {
  "home": "ACCUEIL",
  "news": "NOUVELLES",
  "community": "COMMUNAUTÉ",
  "character": "PERSONNAGES",
  "world": "CADRE DU MONDE",
  "features": "FEATURES",
  "topUp": "TOP UP",
  "customerService": "SERVICE CLIENT",
  "download": "TÉLÉCHARGER",
  "moreDownload": "Plus de méthodes de téléchargement",
  "screenshot": "CAPTURE D'ÉCRAN",
  "video": "CINÉMATIQUE",
  "poster": "POSTER",
  "downloadGame": "TÉLÉCHARGER",
  "scan": "Scanner le code QR pour télécharger",
  "prev": "Précédent",
  "next": "Suivant",
  "moreNews": "INFORMATIONS",
  "latest": "DERNIER",
  "fwtk": "TERMS OF SERVICE",
  "yszc": "PRIVACY POLICY",
  "noContent": "Encore aucun contenu",
  "goPay": "ALLER MAINTENANT",
  "payGuide": "EN SAVOIR PLUS",
  "stayTurn": "Restez à l’affût !",
  "back": "Retour",

}
